/* sk8 Monster Drops, tema 360 (feito sobre o base.js do PS2), base.js.
   Sons: mp3 da ElevenLabs em Arquivos (snippets/midia-360.liquid poe os
   enderecos em SK8.midia); sem eles, o som volta aos osciladores. O vendedor, as
   falas e o balao digitado sairam do site em 18/10/2026 (pedido do Vini).
   Dono: frente 0 (base). Som sintetizado, HUD (som, sacola, cupom), navegacao
   por setas e por controle (teclado e gamepad USB), a abertura (boot do Xbox 360, antes cartao de
   memoria) e o mecanismo do "Comprar agora" (fecha a cortina, marca a
   chegada; o visual do zoom fica em hero.css, a maleta abrindo fica em
   maleta.css). Carrega em toda pagina, sempre antes dos outros arquivos de
   frente, eles leem SK8.som, SK8.importar,
   SK8.atualizarSacola, SK8.$ e SK8.$$ daqui. Expoe tambem SK8.fecharAbertura; espera SK8.fecharJogo (de
   jogo.js) e SK8.fecharLupa (de produto.js) quando essas paginas os definem. */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  SK8.$ = $;
  SK8.$$ = $$;
  var guardar = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  var ler = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var calmo = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* carrega um modulo ES. Nao usa import() direto porque o CDN da Shopify
     minifica este arquivo e troca import() por require(), que nao existe no
     navegador. Uma tag <script type="module"> injetada escapa disso. */
  var esperando = {};
  window.__sk8Modulo = esperando;
  function importar(url) {
    return new Promise(function (ok, erro) {
      var id = "m" + Math.random().toString(36).slice(2);
      esperando[id] = { ok: ok, erro: erro };
      var s = document.createElement("script");
      s.type = "module";
      s.textContent = "import(" + JSON.stringify(url) + ").then(function(m){window.__sk8Modulo[" + JSON.stringify(id) + "].ok(m)},function(e){window.__sk8Modulo[" + JSON.stringify(id) + "].erro(e)})";
      document.head.appendChild(s);
    });
  }
  SK8.importar = importar;

  /* ------------------------------------------------------------------ som
     Nada de arquivo de audio: tudo sai de osciladores, entao nao pesa e nao
     cai por 404. So toca depois do primeiro gesto, que e a regra do navegador. */
  var Som = (function () {
    var ctx = null, mestre = null, liberado = false;
    var ligado = ler("sk8-som") === "on";

    function contexto() {
      if (!ctx) {
        var C = window.AudioContext || window.webkitAudioContext;
        if (!C) return null;
        ctx = new C();
        mestre = ctx.createGain();
        mestre.gain.value = 0.55;
        mestre.connect(ctx.destination);
      }
      if (ctx.state === "suspended") ctx.resume();
      return ctx;
    }

    function tom(f, dur, tipo, vol, atraso, fFim) {
      var c = contexto();
      if (!c) return;
      var t = c.currentTime + (atraso || 0);
      var o = c.createOscillator(), g = c.createGain();
      o.type = tipo || "square";
      o.frequency.setValueAtTime(f, t);
      if (fFim) o.frequency.exponentialRampToValueAtTime(fFim, t + dur);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol || 0.04, t + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g); g.connect(mestre);
      o.start(t); o.stop(t + dur + 0.02);
    }

    function drone() {
      var c = contexto();
      if (!c) return;
      var t = c.currentTime;
      [55, 82.41, 110, 164.8].forEach(function (f, i) {
        var o = c.createOscillator(), g = c.createGain();
        o.type = i === 3 ? "triangle" : "sine";
        o.frequency.value = f;
        o.detune.value = (i - 1.5) * 6;
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(i === 3 ? 0.025 : 0.06, t + 1.2);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 3.6);
        o.connect(g); g.connect(mestre);
        o.start(t); o.stop(t + 3.7);
      });
      [1760, 2637].forEach(function (f, i) { tom(f, 1.4, "sine", 0.012, 0.5 + i * 0.35); });
    }

    /* nome do evento -> arquivo da ElevenLabs (SK8.midia.sons) */
    var MP3 = { mover: "navegar", confirmar: "selecionar", voltar: "voltar", guardar: "adicionar-sacola", erro: "esgotado",
      abertura: "abertura", canal: "trocar-canal", menu: "abrir-menu", tamanho: "escolher-tamanho", cupom: "copiar-cupom" };
    var VOLUME = { mover: 0.35, tamanho: 0.45, abertura: 0.6 };
    var prontos = {};
    function mp3(nome) {
      var url = SK8.midia && SK8.midia.sons && SK8.midia.sons[MP3[nome]];
      if (!url) return null;
      if (!prontos[nome]) { try { prontos[nome] = new Audio(url); prontos[nome].preload = "auto"; } catch (e) { return null; } }
      return prontos[nome];
    }
    function tocarMp3(nome) {
      var a = mp3(nome);
      if (!a) return false;
      try {
        var b = a.cloneNode();
        b.volume = VOLUME[nome] || 0.55;
        var p = b.play(); if (p && p.catch) p.catch(function () {});
      } catch (e) { return false; }
      return true;
    }

    var sons = {
      mover: function () { tom(1320, 0.035, "square", 0.02); },
      confirmar: function () { tom(660, 0.06, "square", 0.035); tom(990, 0.1, "square", 0.035, 0.06); },
      voltar: function () { tom(520, 0.06, "square", 0.03); tom(330, 0.1, "square", 0.03, 0.06); },
      guardar: function () { [523, 659, 784, 1047].forEach(function (f, i) { tom(f, 0.14, "triangle", 0.06, i * 0.07); }); },
      erro: function () { tom(150, 0.22, "sawtooth", 0.04, 0, 90); },
      abertura: drone
    };

    function liberar() {
      if (liberado) return;
      liberado = true;
      if (ligado) contexto();
      try { document.dispatchEvent(new CustomEvent("sk8:som-liberado")); } catch (e) {}
    }
    ["pointerdown", "keydown", "touchstart"].forEach(function (ev) {
      window.addEventListener(ev, liberar, { once: true, passive: true, capture: true });
    });

    return {
      tocar: function (nome) {
        if (!ligado || !liberado) return;
        if (MP3[nome] && tocarMp3(nome)) return;
        if (sons[nome]) try { sons[nome](arguments[1]); } catch (e) {}
      },
      ligado: function () { return ligado; },
      liberado: function () { return liberado; },
      alternar: function () {
        ligado = !ligado;
        guardar("sk8-som", ligado ? "on" : "off");
        if (ligado) { liberar(); if (!tocarMp3("confirmar")) sons.confirmar(); }
        return ligado;
      }
    };
  })();
  SK8.som = Som;

  /* ------------------------------------------------------------------ HUD
     O fundo preto so importa na home (nas outras paginas ele e fixo, no CSS).
     Um marcador invisivel de 40 px no topo da pagina diz quando a pessoa
     rolou: sem ouvir cada evento de rolagem e sem ler scrollY, que obrigava
     o navegador a recalcular o layout da pagina inteira ao abrir (leveza,
     27/09/2026). */
  var hud = $(".hud");
  if (hud && document.body.classList.contains("modelo-index")) {
    if ("IntersectionObserver" in window) {
      var marco = document.createElement("div");
      marco.setAttribute("aria-hidden", "true");
      marco.style.cssText = "position:absolute;left:0;top:0;width:1px;height:40px;visibility:hidden;pointer-events:none";
      document.body.appendChild(marco);
      new IntersectionObserver(function (es) { hud.classList.toggle("solido", !es[es.length - 1].isIntersecting); }).observe(marco);
    } else {
      var hudSolido = function () { hud.classList.toggle("solido", window.scrollY > 40); };
      window.addEventListener("scroll", hudSolido, { passive: true });
      hudSolido();
    }
  }

  /* aba escondida: os videos que estavam tocando param e voltam quando a aba
     volta a aparecer. Os scripts de cada secao continuam decidindo o resto
     (so tocam com o video na tela). */
  document.addEventListener("visibilitychange", function () {
    $$("video").forEach(function (v) {
      if (document.hidden) {
        if (!v.paused) { v.pause(); v.setAttribute("data-parado-aba", ""); }
      } else if (v.hasAttribute("data-parado-aba")) {
        v.removeAttribute("data-parado-aba");
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  });

  $$("[data-som]").forEach(function (b) {
    b.setAttribute("aria-pressed", String(Som.ligado()));
    b.addEventListener("click", function () { b.setAttribute("aria-pressed", String(Som.alternar())); });
  });

  function atualizarSacola(n) {
    $$("[data-sacola]").forEach(function (el) {
      el.classList.toggle("tem", n > 0);
      $$(".contador", el).forEach(function (c) { c.textContent = n; });
      el.setAttribute("aria-label", "Sacola, " + n + (n === 1 ? " item" : " itens"));
      el.classList.remove("pulo"); void el.offsetWidth; el.classList.add("pulo");
    });
    $$("[data-sacola-texto]").forEach(function (el) { el.textContent = n + (n === 1 ? " item guardado" : " itens guardados"); });
  }
  SK8.atualizarSacola = atualizarSacola;

  /* cupom: copiar com gesto; o caminho antigo fica para navegador velho */
  $$("[data-codigo]").forEach(function (b) {
    b.addEventListener("click", function () {
      var codigo = b.getAttribute("data-codigo");
      var aviso = $(".cupom-aviso", b) || $("[data-aviso-cupom]");
      var ok = function () {
        if (aviso) aviso.textContent = "Copiado";
        b.classList.add("copiado");
        Som.tocar("cupom");
        setTimeout(function () { if (aviso) aviso.textContent = ""; b.classList.remove("copiado"); }, 1800);
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(codigo).then(ok, velho);
      else velho();
      function velho() {
        var t = document.createElement("textarea");
        t.value = codigo; t.setAttribute("readonly", ""); t.style.position = "fixed"; t.style.opacity = "0";
        document.body.appendChild(t); t.select();
        try { document.execCommand("copy"); ok(); } catch (e) {}
        t.remove();
      }
    });
  });

  /* ------------------------------------------------------------------ navegacao de jogo
     Setas do teclado e controle USB andam entre os itens marcados com data-nav,
     pelo mais proximo na direcao. Enter e o X do controle confirmam. */
  function sobreposicaoAberta() {
    return $(".modal-jogo:not([hidden])") || $(".lupa:not([hidden])") || $(".abertura:not(.saindo)") || $("#gaveta.aberta") || $(".nxe-guia.aberto");
  }
  function visivel(el) {
    if (!el.offsetParent && getComputedStyle(el).position !== "fixed") return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function alvos() {
    var raiz = sobreposicaoAberta() || document;
    return $$("[data-nav]", raiz).filter(visivel);
  }
  function focar(el) {
    if (!el) return;
    el.focus({ preventScroll: true });
    var r = el.getBoundingClientRect();
    if (r.top < 80 || r.bottom > innerHeight - 20) el.scrollIntoView({ block: "center", behavior: calmo ? "auto" : "smooth" });
  }
  function mover(dir) {
    var lista = alvos();
    if (!lista.length) return;
    var atual = document.activeElement && document.activeElement.closest && document.activeElement.closest("[data-nav]");
    if (!atual || lista.indexOf(atual) < 0) {
      var primeiro = lista.filter(function (el) { var r = el.getBoundingClientRect(); return r.top >= 0 && r.top < innerHeight; })[0] || lista[0];
      focar(primeiro); Som.tocar("mover"); return;
    }
    var a = atual.getBoundingClientRect(), ax = a.left + a.width / 2, ay = a.top + a.height / 2;
    var melhor = null, nota = Infinity;
    lista.forEach(function (el) {
      if (el === atual) return;
      var r = el.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
      var dx = x - ax, dy = y - ay, principal, lateral;
      if (dir === "cima") { if (dy > -4) return; principal = -dy; lateral = Math.abs(dx); }
      if (dir === "baixo") { if (dy < 4) return; principal = dy; lateral = Math.abs(dx); }
      if (dir === "esq") { if (dx > -4) return; principal = -dx; lateral = Math.abs(dy); }
      if (dir === "dir") { if (dx < 4) return; principal = dx; lateral = Math.abs(dy); }
      var n = principal + lateral * 2.2;
      if (n < nota) { nota = n; melhor = el; }
    });
    if (melhor) { focar(melhor); Som.tocar("mover"); }
  }
  function voltar() {
    var jogo = $(".modal-jogo:not([hidden])");
    if (jogo) return SK8.fecharJogo && SK8.fecharJogo();
    var lupa = $(".lupa:not([hidden])");
    if (lupa) return SK8.fecharLupa && SK8.fecharLupa();
    var abertura = $(".abertura:not(.saindo)");
    if (abertura) return SK8.fecharAbertura && SK8.fecharAbertura();
    if ($("#gaveta.aberta")) return SK8.fecharGaveta && SK8.fecharGaveta();
    var guia = $(".nxe-guia.aberto [data-guia-fechar]");
    if (guia) return guia.click();
  }
  var TECLAS = { ArrowUp: "cima", ArrowDown: "baixo", ArrowLeft: "esq", ArrowRight: "dir" };
  document.addEventListener("keydown", function (e) {
    var t = e.target;
    var digitando = t && (t.tagName === "INPUT" && !/radio|checkbox/.test(t.type) || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable);
    if (digitando) return;
    if (e.key === "Escape") { voltar(); Som.tocar("voltar"); return; }
    if (TECLAS[e.key] && !e.altKey && !e.metaKey && !e.ctrlKey) {
      if (t && t.tagName === "CANVAS") return;
      if (t && t.type === "radio") return;
      var naNav = !t || t === document.body || (t.closest && t.closest("[data-nav]"));
      if (!naNav) return;
      e.preventDefault();
      document.documentElement.classList.add("usando-teclado");
      mover(TECLAS[e.key]);
    }
    if ((e.key === "Enter" || e.key === " ") && t && t.closest && t.closest("[data-nav]")) Som.tocar("confirmar");
  });
  document.addEventListener("focusin", function (e) {
    var el = e.target.closest && e.target.closest(".opcao");
    $$(".opcao.ativa").forEach(function (o) { if (o !== el) o.classList.remove("ativa"); });
    if (el) el.classList.add("ativa");
  });
  document.addEventListener("pointerover", function (e) {
    var el = e.target.closest && e.target.closest("[data-nav]");
    if (el && el !== SK8._ultimoHover) { SK8._ultimoHover = el; Som.tocar("mover"); }
  });

  /* controle: botao 0 confirma, 1 volta, 3 abre a sacola, cruz e analogico andam */
  var pads = {}, repetir = {}, rodando = false;
  function lerControle() {
    var lista = navigator.getGamepads ? navigator.getGamepads() : [];
    var agora = performance.now();
    for (var i = 0; i < lista.length; i++) {
      var gp = lista[i];
      if (!gp) continue;
      var antes = pads[gp.index] || {};
      var b = function (n) { return gp.buttons[n] && gp.buttons[n].pressed; };
      var dir = b(12) || gp.axes[1] < -0.6 ? "cima" : b(13) || gp.axes[1] > 0.6 ? "baixo" : b(14) || gp.axes[0] < -0.6 ? "esq" : b(15) || gp.axes[0] > 0.6 ? "dir" : null;
      if (dir && (dir !== antes.dir || agora > (repetir[gp.index] || 0))) {
        mover(dir);
        repetir[gp.index] = agora + (dir === antes.dir ? 140 : 380);
      }
      if (b(0) && !antes.a) { var el = document.activeElement; if (el && el !== document.body) { Som.tocar("confirmar"); el.click(); } else mover("baixo"); }
      if (b(1) && !antes.b) { Som.tocar("voltar"); voltar(); }
      if (b(3) && !antes.y) { if (SK8.abrirGaveta) SK8.abrirGaveta(); else { Som.tocar("confirmar"); location.href = SK8.rotas.sacola; } }
      if (b(9) && !antes.start) { var j = $("[data-abrir-jogo]"); if (j) j.click(); }
      pads[gp.index] = { dir: dir, a: b(0), b: b(1), y: b(3), start: b(9) };
    }
    if (rodando) requestAnimationFrame(lerControle);
  }
  window.addEventListener("gamepadconnected", function () {
    document.documentElement.classList.add("com-controle");
    if (!rodando) { rodando = true; requestAnimationFrame(lerControle); }
  });

  /* ------------------------------------------------------------------ abertura
     Boot do Xbox 360 (snippets/abertura.liquid, animado só por CSS). Só na
     primeira visita da sessão; fecha quando o reflexo da esfera termina e
     qualquer toque ou tecla pula. */
  (function () {
    var ab = $("#abertura");
    if (!ab) return;
    var visto = false;
    try { visto = !!sessionStorage.getItem("sk8-abertura"); } catch (e) {}
    if (visto || calmo) { ab.remove(); document.documentElement.classList.remove("abrindo"); return; }
    try { sessionStorage.setItem("sk8-abertura", "1"); } catch (e) {}
    document.documentElement.classList.add("abrindo");
    var fechada = false;

    function fechar() {
      if (fechada) return;
      fechada = true;
      ab.classList.add("saindo");
      document.documentElement.classList.remove("abrindo");
      document.dispatchEvent(new CustomEvent("sk8:abertura-fechou"));
      Som.tocar("confirmar");
      setTimeout(function () { ab.remove(); }, 400);
    }
    SK8.fecharAbertura = fechar;
    ab.addEventListener("pointerdown", fechar);
    document.addEventListener("keydown", function k() { fechar(); document.removeEventListener("keydown", k); });
    // a animação começa quando a abertura é pintada, que pode ser antes deste
    // arquivo rodar: espera o fim do reflexo pela própria animação, e não por relógio
    var reflexo = (ab.getAnimations ? ab.getAnimations({ subtree: true }) : []).filter(function (a) { return a.animationName === "boot-brilho"; })[0];
    if (reflexo && reflexo.finished) reflexo.finished.then(function () { setTimeout(fechar, 250); }, function () {});
    else setTimeout(fechar, Math.max(1200, 3000 - (window.performance && performance.now ? performance.now() : 0)));
    setTimeout(fechar, 5000); // rede de segurança
  })();

  /* ------------------------------------------------------------------ "Comprar agora"
     Vale em qualquer pagina (HUD, hero, maleta, ficha do produto): fecha a
     cortina preta e, se o link estiver dentro da hero, da zoom nas camisetas
     do casaco antes de sair (o visual do zoom mora em hero.css). Ao chegar
     na maleta, marca a chegada para o veu clarear e a maleta abrir (CSS em
     maleta.css). */
  (function () {
    var hero = $(".hero");
    var saindo = false;
    function prefetch(url) {
      if (SK8._prefetch) return;
      SK8._prefetch = true;
      var l = document.createElement("link");
      l.rel = "prefetch"; l.href = url;
      document.head.appendChild(l);
    }
    $$("[data-comprar-agora]").forEach(function (a) {
      var url = a.getAttribute("href");
      ["pointerenter", "touchstart", "focus"].forEach(function (ev) { a.addEventListener(ev, function () { prefetch(url); }, { passive: true }); });
      a.addEventListener("click", function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0 || saindo) return;
        e.preventDefault();
        saindo = true;
        Som.tocar("confirmar");
        try { sessionStorage.setItem("sk8-chegada", "maleta"); } catch (e2) {}
        var naHero = hero && hero.contains(a);
        var cortina = $(".transicao") || (function () { var d = document.createElement("div"); d.className = "transicao"; document.body.appendChild(d); return d; })();
        if (calmo) { location.href = url; return; }
        if (naHero) {
          hero.classList.add("entrando");
          cortina.classList.add("fechando");
          setTimeout(function () { location.href = url; }, 650);
        } else {
          cortina.classList.add("fechando", "rapido");
          setTimeout(function () { location.href = url; }, 220);
        }
      });
    });
    // voltar pelo navegador devolve a pagina como estava antes do zoom
    window.addEventListener("pageshow", function (e) {
      if (!e.persisted) return;
      saindo = false;
      if (hero) hero.classList.remove("entrando");
      $$(".transicao").forEach(function (c) { c.classList.remove("fechando", "rapido"); });
    });

    // chegada na maleta: a tela clareia e a maleta abre
    var chegou = false;
    try { chegou = sessionStorage.getItem("sk8-chegada") === "maleta"; sessionStorage.removeItem("sk8-chegada"); } catch (e) {}
    if (chegou && document.documentElement.classList.contains("chegando")) {
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        document.documentElement.classList.add("chegou");
        setTimeout(function () { document.documentElement.classList.remove("chegando", "chegou"); }, 350);
      }); });
    } else document.documentElement.classList.remove("chegando");
  })();

  window.SK8 = SK8;
})();
